var ViewConsts = {
    double: 'double',
    single: 'single',
    combined: 'combined',
    doublePageClass: '.double-page-slide',
    coverPageClass: '.cover-slide',
    blockZoomClass: 'block-zoom',
    zoneClass: 'slider-pin-zone',
    pinClass: 'slider-pin',
    productZoneClass: 'product-zone',
    productZoneActiveClass: 'active',
    active: 'active',
    inactive: 'inactive',
    largeImage: 'largeImage',
    mediumImage: 'mediumImage',
    xml: 'xml',
    Products: {
        logo: 'logo',
        product: '0',
        banner: '1',
        text: '2'
    },
    pinType: 1,
    zoneType: 2,
    wordZoneType:3,
    CookieKeys: {
        vwAppPop: 'vwAppPop'
    }
};